export default "__VITE_ASSET__CGZqpIu1__"